import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { ConnectionVersion } from '../../../../../../../constants/common.constants';
import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { ConnectionAudioBridgeFormPresentation } from './connection-audio-bridge-form.presentation';
import { ConnectionAudioBridgeFormVM } from './connection-audio-bridge-form.viewmodel';

export type ConnectionsTemplateFormProps = {
    connection: TConnection;
    addConnection: (connection: TConnection) => void;
    editConnection: (connection: TConnection) => void;
    isAutoSyncLimitReached: boolean;
    connectionVersion: ConnectionVersion;
};

export const ConnectionAudioBridgeForm = withViewModel(ConnectionAudioBridgeFormPresentation, async (props: ConnectionsTemplateFormProps) => {
    const vm = new ConnectionAudioBridgeFormVM(
        props.connection, props.addConnection, props.editConnection, props.connectionVersion, props.isAutoSyncLimitReached
    );

    await vm.initialize();

    return vm;
});
